import React from 'react';
interface PawPrintProps {
  className?: string;
  opacity?: number;
}
export function PawPrint({
  className = '',
  opacity = 0.1
}: PawPrintProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={{
    opacity
  }} xmlns="http://www.w3.org/2000/svg" data-id="element-157">
      <path d="M12 8.5C13.933 8.5 15.5 6.933 15.5 5C15.5 3.067 13.933 1.5 12 1.5C10.067 1.5 8.5 3.067 8.5 5C8.5 6.933 10.067 8.5 12 8.5Z" data-id="element-158" />
      <path d="M6.5 13C8.433 13 10 11.433 10 9.5C10 7.567 8.433 6 6.5 6C4.567 6 3 7.567 3 9.5C3 11.433 4.567 13 6.5 13Z" data-id="element-159" />
      <path d="M17.5 13C19.433 13 21 11.433 21 9.5C21 7.567 19.433 6 17.5 6C15.567 6 14 7.567 14 9.5C14 11.433 15.567 13 17.5 13Z" data-id="element-160" />
      <path d="M12 10.5C9.5 10.5 7.5 12.5 7.5 15C7.5 16.5 8.5 18 10 19C10.5 19.333 11.5 20.5 12 20.5C12.5 20.5 13.5 19.333 14 19C15.5 18 16.5 16.5 16.5 15C16.5 12.5 14.5 10.5 12 10.5Z" data-id="element-161" />
    </svg>;
}